import styled from "styled-components";

export const FormContainer = styled("div")`
  #root_ticker {
    width: 60px;
  }

  #root_mapTo {
    width: 160px;
  }
`;
